import gql from 'graphql-tag'
import { EnumFields } from '..'

// TODO: include [icon, color] when available
export const ContractTypeFragment = gql`
  fragment ContractType on persons_contract_type {
    ${EnumFields}
  }
`
